// @flow

import { useCallback, useEffect } from 'react'
import { BUTTON_KEY_NAMES } from '../../const'

export const keyCodes = {
  33: BUTTON_KEY_NAMES.CHANNEL_UP,
  34: BUTTON_KEY_NAMES.CHANNEL_DOWN,
  13: BUTTON_KEY_NAMES.ENTER,
  [`${13}Up`]: BUTTON_KEY_NAMES.ENTER_UP,
  37: BUTTON_KEY_NAMES.ARROW_LEFT,
  38: BUTTON_KEY_NAMES.ARROW_UP,
  39: BUTTON_KEY_NAMES.ARROW_RIGHT,
  40: BUTTON_KEY_NAMES.ARROW_DOWN,
  461: BUTTON_KEY_NAMES.BACK,
}

export const useInitInput = () => {
  const onKeyDown = useCallback(({ keyCode }) => {
    const handlerName = keyCodes[keyCode]
    if (handlerName) document.dispatchEvent(new CustomEvent(handlerName))
  }, [])

  const onKeyUp = useCallback(({ keyCode }) => {
    const handlerName = keyCodes[`${keyCode}Up`]
    if (handlerName) document.dispatchEvent(new CustomEvent(handlerName))
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [onKeyDown])

  useEffect(() => {
    document.addEventListener('keyup', onKeyUp)
    return () => document.removeEventListener('keyup', onKeyUp)
  }, [onKeyUp])
}
